import ResearchTile from './ResearchTile';

export default ResearchTile;
